import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import Utils from '../../utils/Utils';

let forceUpdateReadProfile = false;
let verifyRead = false;
let enableClick = false;
let firstTimeLoad = true;


const existReadinStorage = () => {
    return DeviceStorage.getItem('profile_read') !== null;
};

const setforceUpdateReadProfile = (value) => {
    forceUpdateReadProfile = value;
};

const loadReadProfileInit = () => {
    // Si no existe en el storage
    return !existReadinStorage() || forceUpdateReadProfile;
};
const setReadProfileStorage = (response) => {
    if (response && typeof response === 'object') {
        const respToStringToHash = aafMD5(JSON.stringify(response));
        const dataToSave = JSON.stringify({
            resp: response,
            hash: respToStringToHash,
            time: Utils.now(true),
        });
        DeviceStorage.setItem('profile_read', dataToSave);
        forceUpdateReadProfile = false;
    }
};
const getReadProfileFromStorage = () => {
    return new Promise((resolve) => {
        resolve(DeviceStorage.getItem('profile_read'));
    });
};

const updateStorageByItems = (response) => {
    const resp = JSON.parse(DeviceStorage.getItem('profile_read'));
    if (resp && resp.resp && resp.resp.data && resp.resp.data.members) {
        resp.resp.data.members = response;
        setReadProfileStorage(resp.resp);
    }
};

const setVerifyRead = (value) => {
    return (verifyRead = value);
};

const getVerifyRead = () => {
    return verifyRead;
};

const setEnableClick = (value) => {
    enableClick = value;
};

const getEnableClick = () => {
    return enableClick;
};

const IsfirstTimeToLoad = () => {
    return firstTimeLoad;
}

const setFirstTimeToLoad = (value) => {
    firstTimeLoad = value;
}

const ProfileReadCache = {
    existReadinStorage,
    loadReadProfileInit,
    setReadProfileStorage,
    getReadProfileFromStorage,
    setforceUpdateReadProfile,
    setVerifyRead,
    getVerifyRead,
    setEnableClick,
    getEnableClick,
    updateStorageByItems,
    IsfirstTimeToLoad,
    setFirstTimeToLoad
};

export default ProfileReadCache;



// WEBPACK FOOTER //
// ./src/AAF/LoaderExp/ProfileReadCache.js